export const statuses = [
	{ id: 'Healthy' },
	{ id: 'Unhealthy' }
];
